import { useContext, useEffect, useState } from 'react';
import MenuPanel from '../Panels/menuPanel/menuPanel';
import UpperPanel from '../Panels/upperPanel/upperPanel';
import './main.scss';
import CentralPanel from '../Panels/centralPanel/centralPanel';
import ViewContext from '../../contexts/viewContext';
import { IsActive, Login } from '../../services/signInService/signInService';
import { apiContext } from '../../contexts/apiContext';
import AuthContext from '../../contexts/authContext';
import { ToastContainer } from 'react-toastify';
import CloseButton from '../../components/snackbar/closeButton';
import esriId from "@arcgis/core/identity/IdentityManager.js";
import esriConfig from "@arcgis/core/config.js";
import { deleteDictPropositions, getDictPropositions, getLoggedUser, setLoggedUser } from '../../database/indexedDbReadWrite';
import { notifyError, notifySuccess, notifyWarn } from '../../components/snackbar/snackbar';
import { addAuthorDictProposal, addAuthorInstitutionDictProposal, addDocumentDictProposal, addInstitutionDictProposal, addPublicationDictProposal } from '../../services/dictionariesService/dictionariesService';
import { sendMessage } from '../../services/communicationService/communicationService';
import ViewTaskListContext from '../../contexts/viewTaskListContext';

const Main = () => {
    const [viewMenu, setViewMenu] = useState(true);
    const [widthMenu, setWidthMenu] = useState('200px');
    const { viewTypes } = useContext(ViewContext);
    const { viewTaskListTypes } = useContext(ViewTaskListContext);
    const [viewType, setViewType] = useState(viewTypes.Home);
    const [viewTaskListType, setViewTaskListType] = useState(viewTaskListTypes.TaskListWaiting);
    const [viewData, setViewData] = useState(null);
    const [krFormSavePrompt, setKrFormSavePrompt] = useState<boolean>(false);
    const { apiUrl, apiVersion, portalUrl, arcGisServerUrl } = useContext(apiContext);
    const { setAuthenticated, authenticated, setUser, onlineMode, setUsername, setOnlineMode } = useContext(AuthContext);
    const [ krFormCallback, setKrFormCallback] = useState<() => void>(() => () => {});
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [userName] = useState(localStorage.getItem("userNameSOPO") !== null ? localStorage.getItem("userNameSOPO") as string : "");
    const [password] = useState(localStorage.getItem("passwordSOPO") !== null ? localStorage.getItem("passwordSOPO") as string : "");
    const [localView, setLocalView] = useState<boolean>(false);
    const [savingLocal, setSavingLocal] = useState<boolean>(false);

    useEffect(() => {
        if (authenticated) {
            IsActive(apiUrl, apiVersion)?.then((res: any) => {

            }).catch((error) => {
                if (error && error.code && error.code === "ERR_NETWORK") {
                    notifyWarn({ message: "Brak dostępu do internetu lub serwera, aplikacja pozostanie w trybie offline" });
                }
                console.log("error", error);
            });
        }
    }, [apiUrl, apiVersion, authenticated]);

    const checkAndSynch = () => {
        getDictPropositions(userName).then((response) => {
            if (response && response.length && response.length > 0) {
                const PromiseArray: Promise<any>[] = [];
                response.forEach((result) => {
                    if (result.type === "author") {
                        PromiseArray.push(addAuthorDictProposal(result.proposition));
                    }
                    if (result.type === "institution") {
                        PromiseArray.push(addInstitutionDictProposal(result.proposition));
                    }
                    if (result.type === "document") {
                        PromiseArray.push(addDocumentDictProposal(result.proposition));
                    }
                    if (result.type === "publication") {
                        PromiseArray.push(addPublicationDictProposal(result.proposition));
                    }
                    if (result.type === "authorLinkInstitution") {
                        PromiseArray.push(addAuthorInstitutionDictProposal(result.proposition));
                    }
                    if (result.type === "message") {
                        PromiseArray.push(sendMessage(apiUrl + apiVersion, result.proposition));
                    }
                })
                if (PromiseArray.length > 0) {
                    Promise.all(PromiseArray).then((responses) => {
                        response.forEach((result) => {
                            deleteDictPropositions(result.guid).then((resultss) => {
                            });
                        });
                        notifySuccess({ message: "Zsynchronizowano wszystkie propozycje słownikowe oraz wiadomości" });
                    }).catch((error) => {
                        response.forEach((result) => {
                            deleteDictPropositions(result.guid).then((resultss) => {
                            });
                        });
                        notifyWarn({ message: "nie udało się zsynchronizować wszystkich danych z bazą" });
                    });
                }
                else {
                    console.log("nothing for synch");
                }
            }
        }).catch((error) => {
            notifyError({ message: "Błąd podczas synchronizacji proponowanych słowników" });
        })
    }

    useEffect(() => {
        if (onlineMode) {
            const workerScript = `
            // eslint-disable-next-line no-restricted-globals
            const interval = self.setInterval(() => {
                postMessage('checkIsActive');
            }, 10000);
            
            // eslint-disable-next-line no-restricted-globals
            self.onmessage = function(e) {
                if (e.data === 'stop') {
                    clearInterval(interval);
                }
            }`;
            const blob = new Blob([workerScript], { type: 'application/javascript' });

            const worker = new Worker(URL.createObjectURL(blob));
            worker.onmessage = (e: any) => {
                if (e.data === 'checkIsActive') {
                    IsActive(apiUrl, apiVersion)?.then((res: any) => {
                        if (res.data === false) {
                            sessionStorage.removeItem("SOPOtoken");
                            sessionStorage.removeItem("SOPOGuidSession");
                            setAuthenticated(false);
                            sessionStorage.removeItem("SOPOonline");
                            setUser('');
                            setLoggedUser({ name: "logged", val: "" })
                            sessionStorage.removeItem("isActiveLoginSOPO");
                        }
                        console.log("intervalWorker");
                    }).catch((error: any) => {
                        console.log("error", error);
                        if (error && error.code && error.code === "ERR_NETWORK") {
                            console.log("localView", localView);
                            if((viewType === viewTypes.KRForm || viewType === viewTypes.POForm) && !localView){
                                notifyWarn({ message: "Brak dostępu do internetu lub serwera, aplikacja przełączyła się na tryb offline" });
                            }
                            else{
                                notifyWarn({ message: "Brak dostępu do internetu lub serwera, aplikacja przełączyła się na tryb offline" });
                            }
                            setOnlineMode(false);
                            worker.postMessage('stop');
                            worker.terminate();
                        }
                    });
                }
            };
            if (authenticated) {
                setTimeout(() => {
                    IsActive(apiUrl, apiVersion)?.then((res: any) => {
                        if (res.data === false) {
                            let token = sessionStorage.getItem("SOPOtoken");
                            let session = sessionStorage.getItem("SOPOGuidSession");
                            getLoggedUser().then((logged) => {
                                Login(logged ? logged.val : userName, password, apiUrl, apiVersion, token, session).then((res: any) => {
                                    sessionStorage.setItem("SOPOtoken", res.data.token);
                                    sessionStorage.setItem("SOPOGuidSession", res.data.guidSession);
                                    esriId.registerToken({
                                        server: arcGisServerUrl,
                                        token: res.data.token
                                    });
                                    esriConfig.portalUrl = portalUrl;
                                    esriConfig.request.interceptors?.push({
                                        // set the `urls` property to the URL of the FeatureLayer so that this
                                        // interceptor only applies to requests made to the FeatureLayer URL
                                        urls: portalUrl + "/sharing/rest/community/users/" + userName,
                                        // use the BeforeInterceptorCallback to add token to query
                                        before: function (params) {
                                            params.requestOptions.query.token = res.data.token;
                                        },
                                    });
                                    setLoggedUser({ name: "logged", val: logged ? logged.val : userName });
                                    setAuthenticated(true);
                                    setUsername(logged ? logged.val : userName);
                                    checkAndSynch();
                                }, (reject: any) => {
                                    if (reject.response !== undefined && reject.response.status === 400) {
                                    }
                                    setTimeout(() => {
                                        notifyError({ message: "Nie można zmienić trybu na online, sesja jest uruchomiona na innym komputerze lub innej zakładce" })
                                    }, 1000);
                                    sessionStorage.removeItem("SOPOtoken");
                                    sessionStorage.removeItem("SOPOGuidSession");
                                    setAuthenticated(false);
                                    sessionStorage.removeItem("SOPOonline");
                                    setUser('');
                                    setLoggedUser({ name: "logged", val: "" })
                                    sessionStorage.removeItem("isActiveLoginSOPO");
                                }).finally(() => {

                                });
                            }).catch((error: any) => {
                                console.log(error);
                            });
                        }
                        else {
                            checkAndSynch();
                        }
                    }).catch((error: any) => {
                        if (error && error.code && error.code === "ERR_NETWORK") {
                            setOnlineMode(false);
                            worker.postMessage('stop');
                            worker.terminate();
                        }
                    });
                    console.log("timeout");
                }, 1000);
            }
            return () => {
                worker.postMessage('stop');
                worker.terminate();
            };
        }
        else {

        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [apiUrl, apiVersion, setAuthenticated, authenticated, setUser, onlineMode]);

    useEffect(() => {
        viewMenu ? setWidthMenu('200px') : setWidthMenu('60px');
    }, [viewMenu]);

    esriId.registerToken({
        server: arcGisServerUrl,
        token: sessionStorage.getItem("SOPOtoken")?.toString() as string
    });
    esriConfig.portalUrl = portalUrl;
    esriConfig.request.timeout = 120000;
    esriConfig.request.interceptors?.push({
        // set the `urls` property to the URL of the FeatureLayer so that this
        // interceptor only applies to requests made to the FeatureLayer URL
        urls: portalUrl + "/sharing/rest/community/users/" + sessionStorage.getItem("isActiveLoginSOPO"),
        // use the BeforeInterceptorCallback to add token to query
        before: function (params) {
            params.requestOptions.query.token = sessionStorage.getItem("SOPOtoken");
        },
    });

    return (
        <ViewContext.Provider value={{ viewTypes, viewType, setViewType, viewData, setViewData, krFormSavePrompt, 
        setKrFormSavePrompt, krFormCallback, setKrFormCallback, localView, setLocalView, savingLocal, setSavingLocal }}>
            <ViewTaskListContext.Provider value={{ viewTaskListTypes, viewTaskListType, setViewTaskListType }}>
                <div className="mainWrapper">
                    <div className="upperPanel">
                        <UpperPanel />
                        <hr />
                    </div>
                    <div className="menuPanel" style={{ width: widthMenu }}>
                        <MenuPanel setViewMenu={setViewMenu} menuOpened={viewMenu} />
                    </div>
                    <div className="centralPanel">
                        <CentralPanel />
                    </div>
                </div>
                <ToastContainer closeButton={CloseButton} />
            </ViewTaskListContext.Provider>
        </ViewContext.Provider>
    )
}

export default Main;